"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransaction = void 0;

var eth_1 = require("web3x/eth");

var address_1 = require("web3x/address");

var eth_2 = require("../../lib/eth");

var types_1 = require("./types");

function getTransaction(address, chainId, hash) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var provider, eth, currentNonce, response, _tx2, _tx3, _tx, receipt, _tx4, tx;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return eth_2.getNetworkProvider(chainId);

          case 2:
            provider = _context.sent;

            if (provider) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", null);

          case 5:
            eth = new eth_1.Eth(provider);

            if (address) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", null);

          case 8:
            currentNonce = null;
            _context.prev = 9;
            _context.next = 12;
            return eth.getTransactionCount(address_1.Address.fromString(address));

          case 12:
            currentNonce = _context.sent;
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](9);
            console.warn("Could not get current nonce for account \"".concat(address, "\""), _context.t0.message);

          case 18:
            response = null;
            _context.prev = 19;
            _context.next = 22;
            return eth.getTransaction(hash);

          case 22:
            response = _context.sent;
            _context.next = 28;
            break;

          case 25:
            _context.prev = 25;
            _context.t1 = _context["catch"](19);
            console.warn("Could not get transaction for hash \"".concat(hash, "\""), _context.t1.message);

          case 28:
            if (!(response == null)) {
              _context.next = 30;
              break;
            }

            return _context.abrupt("return", null);

          case 30:
            if (!(response.blockNumber == null)) {
              _context.next = 40;
              break;
            }

            if (!(currentNonce != null)) {
              _context.next = 38;
              break;
            }

            if (!(response.nonce < currentNonce)) {
              _context.next = 35;
              break;
            }

            _tx2 = {
              hash: hash,
              status: types_1.TransactionStatus.REPLACED,
              nonce: response.nonce
            };
            return _context.abrupt("return", _tx2);

          case 35:
            if (!(response.nonce > currentNonce)) {
              _context.next = 38;
              break;
            }

            _tx3 = {
              hash: hash,
              status: types_1.TransactionStatus.QUEUED,
              nonce: response.nonce
            };
            return _context.abrupt("return", _tx3);

          case 38:
            // pending
            _tx = Object.assign({
              status: types_1.TransactionStatus.PENDING
            }, response);
            return _context.abrupt("return", _tx);

          case 40:
            _context.next = 42;
            return eth.getTransactionReceipt(hash);

          case 42:
            receipt = _context.sent;

            if (!(receipt == null || !receipt.status)) {
              _context.next = 46;
              break;
            }

            _tx4 = Object.assign({
              status: types_1.TransactionStatus.REVERTED
            }, response);
            return _context.abrupt("return", _tx4);

          case 46:
            // confirmed
            tx = Object.assign(Object.assign({
              status: types_1.TransactionStatus.CONFIRMED
            }, response), {
              receipt: receipt
            });
            return _context.abrupt("return", tx);

          case 48:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 15], [19, 25]]);
  }));
}

exports.getTransaction = getTransaction;